<template>
	<div class="send-form">
		<div class="loading-container" v-if="loading">
			<spinner-large />
			<h2 class="mobile-H5-5">Sending...</h2>
		</div>
		<div class="success-container" v-if="!loading">
			<div class="success-check">
				<large-success-check />
			</div>
			<h2 class="mobile-H5-5">{{ successTitle }}</h2>
			<h6 v-if="successBody" class="mobile-body-2">{{ successBody }}</h6>
			<md-button
        id="send-form-button"
        class="md-primary md-raised md-button-large"
        @click="$emit('backToWorkflow')"
      >
        Back to my experiment
      </md-button>
		</div>
	</div>
</template>

<script>
import SpinnerLarge from '@/components/icons/SpinnerLarge.vue';
import LargeSuccessCheck from '@/components/icons/LargeSuccessCheck.vue';

export default {
	name: 'SendingForm',
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
    successTitle: {
		  type: String,
      default: 'Your query has been submitted',
    },
    successBody: {
      type: String,
      default: 'You\'ll receive an email confirmation shortly.',
    }
	},
	components: {SpinnerLarge, LargeSuccessCheck},
};
</script>

<style lang="scss" scoped>
.send-form {
	width: 100%;
	height: 100%;
	margin-top: 112px;

  @media (max-width: $mobile) {
    margin-top: 46px;
    width: 100%;
  }

  #send-form-button {
    margin-top: 46px;
    @media (max-width: $mobile) {
      width: 100%;
    }
  }

  .success-check svg {
    @media (max-width: $mobile) {
      height: 60px;
      width: 60px;
    }
  }


	.loading-container,
	.success-container {
		@include flexColumn;
		align-items: center;
		justify-content: center;
		h2 {
			color: $color-text-grey;
		}
		svg.save-btn-icon {
			opacity: 1;
			width: 124px;
		}
	}
	.loading-container {
		svg {
			margin-bottom: 55px;
		}
	}
	.success-container {
		svg path:nth-child(1) {
			transform: translate(20px, 32px);
		}
	}
}
</style>
